import AdOptions from './AdOptions';

const AdOptionsDirective = (
  reactDirective,
  $state,
  CreativeListService,
  FlashService,
  ShareableLinkService
) => {
  return reactDirective(
    AdOptions,
    undefined,
    {
      restrict: 'E'
    },
    {
      $state,
      CreativeListService,
      FlashService,
      ShareableLinkService
    }
  );
};

AdOptionsDirective.$inject = [
  'reactDirective',
  '$state',
  'CreativeListService',
  'FlashService',
  'ShareableLinkService'
];

export default AdOptionsDirective;
